export const Role = {
    ADMIN: 'ADMIN',
    COORDINATOR: 'COORDINATOR',
    DISTRIBUTOR: 'DISTRIBUTOR',
    INSTALLER: 'INSTALLER',
    WAREHOUSE: 'WAREHOUSE',
    FINANCIAL: 'FINANCIAL',
    MANAGER: 'MANAGER',
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const WEB_ALLOWED_ROLES: Role[] = [
    Role.ADMIN,
    Role.COORDINATOR,
    Role.DISTRIBUTOR,
    Role.INSTALLER,
    Role.WAREHOUSE,
    Role.FINANCIAL,
];
